import styled from 'styled-components'
import { ImageAsset } from '@/components/common'

interface CartCounterProps {
  value: number
  onChange: (value: number) => void
  min?: number
  max?: number
  isDisabled?: boolean
  isDisabledAdd?: boolean
}
export const CartCounter = ({
  value: count,
  onChange,
  min = 1,
  max,
  isDisabled = false,
  isDisabledAdd,
}: CartCounterProps) => {
  const handleClickSubtractButton = () => {
    onChange(count - 1)
  }

  const handleClickAddButton = () => {
    onChange(count + 1)
  }

  return (
    <StyledQuantityControl>
      <div className="quantity-control">
        <button
          disabled={min === count || isDisabled}
          onClick={handleClickSubtractButton}
          type="button"
          className="quantity-control__subtract"
        >
          <ImageAsset name={min === count || isDisabled ? 'ic_remove_gray200_20' : 'ic_remove_gray_20'} size={20} svg />
        </button>
        <span className="quantity-control__input">{count}</span>
        <button
          disabled={max === count || isDisabled || isDisabledAdd}
          onClick={handleClickAddButton}
          type="button"
          className="quantity-control__add"
        >
          <ImageAsset
            name={max === count || isDisabled || isDisabledAdd ? 'ic_plus_gray200_20' : 'ic_plus_gray_20'}
            size={20}
            svg
          />
        </button>
      </div>
    </StyledQuantityControl>
  )
}

const StyledQuantityControl = styled.div`
  .quantity-control {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({
      theme: {
        color: { grayWhite },
      },
    }) => grayWhite};
    border-radius: 0.8rem;
    border: 0.1rem solid
      ${({
        theme: {
          color: { gray200 },
        },
      }) => gray200};
    &__subtract,
    &__add {
      padding: 0.8rem;
      cursor: pointer;
      border: none;
      background-color: transparent;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &__input {
      // Body2Regular
      font-size: 1.5rem;
      font-style: normal;
      font-weight: 400;
      line-height: 2rem; /* 133.333% */
      letter-spacing: -0.03rem;
      outline: none;
      text-align: center;
      font-variant-numeric: tabular-nums;
      width: 3.6rem;
      padding: 0.8rem;
      border: 0.1rem solid
        ${({
          theme: {
            color: { gray200 },
          },
        }) => gray200};
      border-top: none;
      border-bottom: none;
    }
  }
`
